import { hubConnection } from "signalr-no-jquery";
import { InstantMessageListItem } from "../instantMessage/instantMessageListItem";
import { InstantMessageChannelItem } from "../instantMessage/instantMessageChannelItem";
import { SignalrNotification } from "../common/signalrNotification";
var SignalRConnectionManager = /** @class */ (function () {
    function SignalRConnectionManager() {
        var _this = this;
        //appConfig.rootUrl
        this.openConnection = function (rootUrl, operations, signalRToken) {
            if (signalRToken === void 0) { signalRToken = null; }
            if (_this.openingConnection || _this.connection)
                return;
            _this.openingConnection = true;
            _this.connection = hubConnection(rootUrl.substr(0, rootUrl.length - 1), { qs: "st=" + (signalRToken !== null && signalRToken !== void 0 ? signalRToken : "") });
            _this.hub = _this.connection.createHubProxy("SignalRHub");
            if (operations.onUpdateInstantMessageListLine) {
                _this.hub
                    .off("updateInstantMessageListLine")
                    .on("updateInstantMessageListLine", function (item) {
                    if (!item)
                        return;
                    operations.onUpdateInstantMessageListLine(new InstantMessageListItem(item));
                });
            }
            if (operations.onRemoveInstantMessageChannel) {
                _this.hub
                    .off("removeInstantMessageChannel")
                    .on("removeInstantMessageChannel", function (instantMessageChannelId) {
                    if (!instantMessageChannelId)
                        return;
                    operations.onRemoveInstantMessageChannel(instantMessageChannelId);
                });
            }
            if (operations.onUpdateInstantMessageChannel) {
                _this.hub
                    .off("updateInstantMessageChannel")
                    .on("updateInstantMessageChannel", function (channel) {
                    if (!channel)
                        return;
                    operations.onUpdateInstantMessageChannel(new InstantMessageChannelItem(channel));
                });
            }
            if (operations.onShowNotification) {
                _this.hub
                    .off("showNotification")
                    .on("showNotification", function (item) {
                    if (!item)
                        return;
                    operations.onShowNotification(new SignalrNotification(item));
                });
            }
            _this.connection.start()
                .done(function () {
                _this.openingConnection = false;
                console.log("[App] SignalR connected, id = " + _this.connection.id);
            }).fail(function (error) {
                _this.openingConnection = false;
                _this.connection = null;
                _this.hub = null;
                console.log("[App] SignalR connection error = " + error);
            });
        };
        this.closeConnection = function () {
            if (!_this.connection)
                return;
            _this.connection.stop(true, true);
            _this.connection = null;
            _this.hub = null;
        };
    }
    return SignalRConnectionManager;
}());
export { SignalRConnectionManager };
